// AI models in use (#1234: Sky SKY-08, SKY-09, SKY-20, SKY-23): every AI
// model Platinum uses for the customer, where it runs, its model card, the
// customer's UK/EEA only and ThemeAI switches, and the Changes list. It only
// points: switches are never clicked by a walkthrough, and Add change is
// never pressed. Nothing is changed.
// Opened on the page itself: /admin/<customer>/ai-models?walkthrough=ai-models-in-use.

import type { Walkthrough } from './types'

export const aiModelsInUse: Walkthrough = {
  slug: 'ai-models-in-use',
  title: 'AI models in use',
  summary:
    'Shows the page that lists every AI model Platinum uses for a customer, where each one runs and how, its model card, the UK/EEA only and ThemeAI settings, and the Changes list. Nothing is changed.',
  issue: '#1234',
  added: '2026-10-27',
  audience: 'realm',
  steps: [
    {
      page: 'admin-ai-models',
      feature: 'people/ai-models',
      say: 'This is AI models in use, under AI in the Admin menu. Realm admins and Managers can open it. Each row is one AI model Platinum uses: what it is used for, the provider, the region and the deployment type.',
    },
    {
      page: 'admin-ai-models',
      feature: 'people/ai-models',
      control: 'Model card',
      say: 'Processing says whether a model’s work stays in the UK/EEA. A GlobalStandard deployment may be processed in any region, even when it sits in the UK. Model card opens the provider’s own description of the model.',
    },
    {
      page: 'admin-ai-models',
      feature: 'people/ai-models-settings',
      control: 'UK/EEA only',
      say: 'UK/EEA only, when a Manager turns it on, makes Platinum refuse every model that may process this customer’s data outside the UK or the EEA. Refused rows are marked. Everyone else sees the switch disabled, with the reason.',
    },
    {
      page: 'admin-ai-models',
      feature: 'people/ai-models-settings',
      control: 'ThemeAI sentiment',
      say: 'ThemeAI sentiment and ThemeAI emotion say whether ThemeAI may add those codes for this customer. Switched off, Add sentiment or Add emotion in ThemeAI is shown off with the reason, and a run that asks for it is refused.',
    },
    {
      page: 'admin-ai-models',
      feature: 'people/ai-models-changes',
      control: 'What changed',
      say: 'Changes is a list a Manager keeps: the date, what changed, and when the customer was told. Platinum never tells the customer itself; the person who makes a change does, and records the date here.',
    },
  ],
}
